import { Injectable } from '@angular/core';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import {
	DATE_MDY,
	INTEGRATION_TYPE,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	VETTING_SOURCE,
} from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class HaulpayService {
	constructor(private cargochief: Cargochief) {}

	logo() {
		return 'assets/icons/haulpay.png';
	}

	tooltip() {
		return `HaulPay Approved carriers have had their payment ID verified and cross checked with their authority for added trust.`;
	}
}
